import type { SoundResourceType } from "@pp/core/src/controllers/audioController/types";
import { getStaticResourceUrl } from '@pp/core/src/utils/getStaticBaseUrl';

export const soundResources: SoundResourceType[] = [
  {
    name: 'musicLoop',
    url: getStaticResourceUrl('assets/sounds/music_Loop.mp3'),
  },
  {
    name: 'winSound',
    url: getStaticResourceUrl('assets/sounds/sfx_YouWin.mp3'),
  },
  {
    name: 'crashV2',
    url: getStaticResourceUrl('assets/sounds/sfx_CrashV2.mp3'),
  },
  {
    name: 'jackpot',
    url: getStaticResourceUrl('assets/sounds/sfx_Jackpot.mp3'),
  },
  {
    name: 'StartBeep',
    url: getStaticResourceUrl('assets/sounds/sfx_StartBeep.mp3'),
  },
];

export enum GameVolumeChannels {
  Background = 'background',
  Game = 'game',
  Studio = 'studio',
}
